export default __webpack_public_path__ + "assets/images/c7e693d9f509e5af9a052f50e6350a86.png";